import React from 'react';

import { logger } from '../lib/logger';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(/*error*/) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    error.meta = {
      contentTypeId: this.props.contentTypeId,
    };
    logger.error(
      error,
      {
        message: 'Failed to load content row for content type.',
      },
      errorInfo
    );
  }

  render() {
    if (this.state.hasError) {
      return <div />;
    }

    return this.props.children;
  }
}
